module.exports = __webpack_public_path__ + "img/journey.fa99eefb.svg";